import Vue from "vue";
import VueRouter from "vue-router";
import View from "./components/View.vue";

Vue.use(VueRouter);

export function buildRouter() {
	const routes = [
		{path: "/view", component: View}
	];

	return {
		router: new VueRouter({
			routes, mode: "abstract"
		})
	};
}
